export enum Currency {
  USD = 'USD',
  RUB = 'RUB',
  EUR = 'EUR',
}

export enum OrderStatus {
  Working = 0,
  Hold = 1,
  Processing = 2,
  Ready = 4,
  Success = 8,
  Rejected = 3,
}

export enum PlayerFormat {
  Slider = 1,
  Interstitial = 2, // disabled
  InPage = 3,
  // это инстрим -> preroll -> vpaid
  VPAID = 4, // disabled
  Floating = 5,
  AdWall = 7,
  Branding = 8,
  Curtain = 9,
}

export enum AccountType {
  Company = 'company',
  Individual = 'individual',
  SelfEmployed = 'self_employed',
}

interface IId {
  id: string | number;
}

export interface ISelectable<T extends IId> {
  isItemSelected: (item: T['id']) => boolean;
  getSelectedItemsCount: (totalItemsCount: number) => number;
  toggleItemSelection: (item: T['id']) => void;
  selectAllItems: () => void;
}
